import { PaletteMode } from "@mui/material";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../../redux/store";
import { IMessage } from "../../types/notif";

interface SettingState {
  hasScroll?: boolean;
  themeMode: PaletteMode;
  openSidebar: boolean;
  authSidebar: boolean;
  driverSidebar: boolean;
  ownerSidebar: boolean;
  ownerTypeRegister: "individual" | "legal-entity";
  loginGrids: "user" | "company";
  userLoginTab: "burdenOwner" | "drivers";
  userSignupTab: "burdenOwner" | "drivers";
  signupGrids: "user" | "company";
  CampanyRegisterStep: "CompanyInfo" | "ManagerInfo" | "ApproveInfo";
  isOpenKeyboard: boolean;
  messages?: IMessage[];
}

const themeMode = localStorage.getItem("themeMode")
  ? JSON.parse(localStorage.getItem("themeMode") || "")
  : "light";

type AuthRole = "burdenOwner" | "drivers";

const readStoredRole = (key: string): AuthRole => {
  try {
    return sessionStorage.getItem(key) === "burdenOwner"
      ? "burdenOwner"
      : "drivers";
  } catch {
    return "drivers";
  }
};

const storeRole = (key: string, role: AuthRole) => {
  try {
    sessionStorage.setItem(key, role);
  } catch {
    /* ignore private-mode storage errors */
  }
};

const initialState: SettingState = {
  themeMode: themeMode,
  openSidebar: false,
  authSidebar: false,
  driverSidebar: false,
  ownerSidebar: false,
  loginGrids: "user",
  signupGrids: "user",
  ownerTypeRegister: "individual",
  userLoginTab: readStoredRole("userLoginTab"),
  userSignupTab: readStoredRole("userSignupTab"),
  CampanyRegisterStep: "CompanyInfo",
  isOpenKeyboard: false,
};

export const settingSlice = createSlice({
  name: "setting",
  initialState,

  reducers: {
    setThemeMode: (state, action: PayloadAction<PaletteMode>) => {
      state.themeMode = action.payload;
      let mode = JSON.stringify(action.payload);
      localStorage.setItem("themeMode", mode);
    },

    setOpenSidebar: (state, action: PayloadAction<boolean>) => {
      state.openSidebar = action.payload;
    },
    setOpenDriverSidebar: (state, action: PayloadAction<boolean>) => {
      state.driverSidebar = action.payload;
    },

    setOpenOwnerSidebar: (state, action: PayloadAction<boolean>) => {
      state.ownerSidebar = action.payload;
    },

    setOpenAuthSidebar: (state, action: PayloadAction<boolean>) => {
      state.authSidebar = action.payload;
    },

    changeLoginType: (state, action: PayloadAction<"company" | "user">) => {
      state.loginGrids = action.payload;
    },
    changeSignupType: (state, action: PayloadAction<"user" | "company">) => {
      console.log(state.signupGrids);

      // state.signupGrids = state.signupGrids === "user" ? "company" : "user";
      state.signupGrids = action.payload;
    },
    handleUserLoginTabbar: (
      state,
      action: PayloadAction<"burdenOwner" | "drivers">
    ) => {
      state.userLoginTab = action.payload;
      storeRole("userLoginTab", action.payload);
    },
    handleUserSignupTabbar: (
      state,
      action: PayloadAction<"burdenOwner" | "drivers">
    ) => {
      state.userSignupTab = action.payload;
      storeRole("userSignupTab", action.payload);
    },
    changeSignupCompanyStep: (
      state,
      action: PayloadAction<"CompanyInfo" | "ManagerInfo" | "ApproveInfo">
    ) => {
      state.CampanyRegisterStep = action.payload;
    },

    toggleKeyboard: (state, action: PayloadAction<boolean>) => {
      state.isOpenKeyboard = action.payload;
    },
    handleOwnerTypeRegister: (
      state,
      action: PayloadAction<"individual" | "legal-entity">
    ) => {
      state.ownerTypeRegister = action.payload;
    },

    setMessages: (state, action: PayloadAction<IMessage[]>) => {
      state.messages = action.payload;
    },

    setHasScroll: (state, action: PayloadAction<boolean>) => {
      state.hasScroll = action.payload;
    },
  },
});

export const getSettingState = (state: RootState) => state.settings;
export const {
  setThemeMode,
  setOpenSidebar,
  setOpenAuthSidebar,
  setOpenOwnerSidebar,
  setOpenDriverSidebar,
  changeLoginType,
  handleUserLoginTabbar,
  handleUserSignupTabbar,
  changeSignupType,
  changeSignupCompanyStep,
  toggleKeyboard,
  handleOwnerTypeRegister,
  setMessages,
  setHasScroll,
} = settingSlice.actions;

export default settingSlice.reducer;
